module.exports = __webpack_public_path__ + "img/12.b7eb59af.png";